import type { IUseCase } from '@/shared/contracts/use-case.contract';
import type { IHttpClient } from '@/shared/contracts/http-client.contract';
import { HttpMethod } from '@/shared/contracts/http-client.contract';

type UseCaseInput = { cep: string };

type UseCaseOutput = {
  street: string;
  district: string;
  city: string;
  state: string;
  cep: string;
  latitude: number;
  longitude: number;
};

export class LookupCepUseCase implements IUseCase<UseCaseInput, UseCaseOutput> {
  private client: IHttpClient;

  constructor(client: IHttpClient) {
    this.client = client;
  }

  async execute(input: UseCaseInput): Promise<UseCaseOutput> {
    const response = await this.client.sendRequest<UseCaseOutput, never>({
      method: HttpMethod.GET,
      endpoint: 'api/app/coordinates-by-cep',
      params: { cep: input.cep },
    });

    return response;
  }
}
